import React from 'react';
import { Menu, Search } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import InternalMessageCenter from './InternalMessageCenter';

const Header = ({ onMenuClick }) => {
  const { user } = useAuth();

  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
        {/* 모바일 메뉴 버튼 */}
        <button
          type="button"
          className="lg:hidden p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary-500"
          onClick={onMenuClick}
        >
          <Menu className="h-6 w-6" />
        </button>

        {/* 검색바 */}
        <div className="flex-1 max-w-lg lg:max-w-xs">
          <label htmlFor="search" className="sr-only">
            검색
          </label>
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-5 w-5 text-gray-400" />
            </div>
            <input
              id="search"
              name="search"
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
              placeholder="검색..."
              type="search"
            />
          </div>
        </div>

        {/* 우측 아이콘들 */}
        <div className="flex items-center space-x-4">
          {/* 알림 */}
          <InternalMessageCenter />

          {/* 사용자 프로필 */}
          <div className="flex items-center space-x-3">
            <div className="hidden sm:block">
              <p className="text-sm font-medium text-gray-900">
                {user?.name || '사용자'}
              </p>
              <p className="text-xs text-gray-500">
                {user?.role === 'admin' ? '관리자' : 
                 user?.role === 'property_owner' ? '임대인' : '임대관리자'}
              </p>
            </div>
            <div className="w-8 h-8 bg-primary-100 rounded-full flex items-center justify-center">
              <span className="text-sm font-medium text-primary-600">
                {user?.name?.charAt(0) || 'U'}
              </span>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;





